// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5714) return "static/chunks/5714-6431a23c06c2ff52.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7405":"c9f7b777","9642":"17d537d6"}[chunkId] || chunkId) + "." + {"7405":"e167438465bd1f0f","9257":"f08066d26b639245","9642":"4990cce0cc547865"}[chunkId] + ".js";
};